import React from "react"
import { Helmet } from "react-helmet"

/**
 * @param pageTitle - pageTitle
 * @param title - title
 * @param description - description
 * @param url - page url
 * @param imgSrc - img src
 * */
const Seo = ({ pageTitle, title, description, url, imgSrc }) => {
  return (
    <Helmet>
      <title>{pageTitle}</title>
      {/*description*/}
      <meta name="description" content={description} />

      {/*page title and og share*/}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={imgSrc} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="628" />
      <meta property="og:image:alt" content={description} />

      {/*TWITTER CARDS*/}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imgSrc} />
      <meta name="twitter:image:alt" content={description} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  )
}

export default Seo
